export default "__VITE_ASSET__41b217cb__"